module.exports = __webpack_public_path__ + "static/media/glass-whiskey-rocks.6c1ac4e4.svg";